import { compareValuesNullsLast } from '@/components/shared-table/utils'
import { buildColumnDef, getFormattedValue, getModelPredictionRoot } from '@/components/shared-table/buildColumnDef'

const getCategoryValue = (predictionForModel) => {
  if (Array.isArray(predictionForModel)) {
    return predictionForModel
      .filter(Boolean)
      .map((entry) => String(entry))
      .join(', ')
  }
  return predictionForModel ? String(predictionForModel) : null
}

const buildPfasAtlasColumnDef = ({ column, visibleColumnIds, tableSettings }) =>
  buildColumnDef({
    column,
    visibleColumnIds,
    tableSettings,

    type: [],

    wrapText: true,
    autoHeight: true,

    tooltipValueGetter: (params) => getCategoryValue(params?.value),

    valueGetter: (params) => getModelPredictionRoot(params?.data?.predictionsByModelId, column?.modelId),

    valueFormatter: (params) =>
      getFormattedValue({
        params,
        column,
        formatFunction: () => getCategoryValue(params?.value),
      }),

    comparator: (aValue, bValue, _nodeA, _nodeB, isDescending) =>
      compareValuesNullsLast(getCategoryValue(aValue), getCategoryValue(bValue), isDescending),

    cellClass: '',
  })

export { buildPfasAtlasColumnDef }
